import { IModel, Model, ModelRecord } from './Model';
import { NoteTypeModel } from './NoteTypeModel';

export interface IInvoiceNoteModel extends IModel {
  invoiceNoteId: number;
  invoiceId: number;
  noteTypeId: number;
  noteType: NoteTypeModel;
  notes: string;
  isPrivate: boolean;
}

export class InvoiceNoteModel
  extends Model
  implements ModelRecord<IInvoiceNoteModel>
{
  invoiceNoteId: number;
  invoiceId: number;
  noteTypeId: number;
  noteType: NoteTypeModel;
  notes: string;
  isPrivate: boolean;

  constructor(params?: Partial<IInvoiceNoteModel>) {
    super(params);
    this.invoiceNoteId = _.defaultTo(params?.invoiceNoteId, 0);
    this.invoiceId = _.defaultTo(params?.invoiceId, 0);
    this.noteTypeId = _.defaultTo(params?.noteTypeId, 0);
    this.noteType = params?.noteType
      ? new NoteTypeModel(params?.noteType)
      : new NoteTypeModel();
    this.notes = _.defaultTo(params?.notes, '');
    this.isPrivate = _.defaultTo(params?.isPrivate, true);
  }
}
